import React from "react";
import { Nav, NavItem } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import { STORAGE, makeRequest, makeRequestAuth } from "../../utils/globals";
import config from "config";
import LogoutLoader from "../LogoutLoader";
import { XoxodayLongLogo } from "../Icons";

class SidebarFooter extends React.Component {
  state = {
    isLoading: false,
  };

  accountLogout = () => {
    this.setState({ isLoading: true });
    makeRequestAuth(
      {},
      function (res) {
        STORAGE("jose", "", 1);
        STORAGE("login_email", "", 1);
        STORAGE("e_login", "", 1);
        STORAGE("e_points", "", 1);
        STORAGE("member_id", "", 1);
        STORAGE("logo_url", "", true);

        let delete_params = STORAGE("delete_params")
          ? STORAGE("delete_params").split(",")
          : [];
        for (var i = 0; i < delete_params.length; i++) {
          STORAGE(delete_params[i], "", 1);
        }
        STORAGE("delete_params", "", 1);
        sessionStorage.removeItem("xoxoPointsState");
        sessionStorage.removeItem("xoxoCodeState");
        this.setState({ isLoading: false });
        window.location.href = config.storeFrontURL;
      }.bind(this),
      {},
      "/logout"
    );
  };

  render() {
    //target="_blank" href={config.storeFrontUrl}
    const { isLoading } = this.state;
    return null;
    return (
      <>
        <Nav className="nav-stacked nav-tabs nav-footer">
          <NavItem>
            <a
              href="https://xoxoday.com"
              className={"nav-link sidebar-footer"}
              activeClassName="active"
              target="_blank"
            >
              <span>
                <XoxodayLongLogo width="80" />
              </span>
            </a>
          </NavItem>
        </Nav>
        {isLoading ? (
          <LogoutLoader msg={"Please wait Logging you out !!!"} />
        ) : null}
      </>
    );
  }
}

export default SidebarFooter;
